import $ from "jquery";
import orderListUtil, { processAllOrders, updateOrders, tmplparams, updateTableMates, update, deleteOrders, simpleChangeStateByTableAndMenuItem, resetOrderListUtil, deleteTableOccupations, getTableName, getTableOccupation, isTakeawayTable, playNewAcceptedOrderSound, getOrderById, addRejectionReason } from "./order-list-util";
import admin, { getLocalPrinterSettings, getProductionLine, getTableOccupations } from "./admin";
import auth, { startpoll, replaceContent, select, get, post } from "./auth";
import tableLayout from "./table-layout";
import moment from "moment";
import { allstates2, alltimings } from "./order-grouping";
import { getCrc, getCrc2 } from "./tables-overview";

var updateCycle;
export const stopIntervals = () => {
  delete window.printLabel;
  delete window.printAllLabels;
  clearInterval(updateCycle);
};

const isPickup = tableNumber => Number(tableNumber) === auth.myStatus.restaurant_settings["enabled-features"].pickup["table-number"];
const isHomeDelivery = tableNumber => Number(tableNumber) === auth.myStatus.restaurant_settings["enabled-features"].homedelivery["table-number"];

export const ready = () => {
  resetOrderListUtil();

  delete sessionStorage.tableOccupationSelected;

  window.toggleProductionLineSelected = toggleProductionLineSelected;
  window.simpleChangeStateByTableAndMenuItem = simpleChangeStateByTableAndMenuItem;
  window.getTableName = getTableName;
  window.getTableOccupation = getTableOccupation;
  window.moment = moment;
  window.isTakeawayTable = isTakeawayTable;
  window.printLabel = printLabel;
  window.printAllLabels = printAllLabels;
  window.addRejectionReason = addRejectionReason;
  window.getSelectedProductionLines = getSelectedProductionLines;

  orderListUtil.showTableNumber = true;
  orderListUtil.filterOrders = false;
  orderListUtil.states = auth.myStatus.restaurant_settings["tables-overview"].states;

  orderListUtil.processOrdersDone = function () {
    topUpdateHooks();
  };

  updateCycle = setInterval(function () {
    if (typeof orderListUtil.ordersCache != "undefined") {
      processAllOrders(orderListUtil.ordersCache);
      updateOrders([]);
    }
  }, 5000);

  orderListUtil.show2 = function (order) {
    return getSelectedProductionLines().find(productionLineSelected =>
      typeof order.productionLinesInvolved["pl" + productionLineSelected] != "undefined"
    );
  };

  orderListUtil.show = function (order) {
    if (!order.date || moment(order.date).startOf("day").valueOf() == moment().startOf("day").valueOf()) {
      var ok = Object.values(order.productionLinesInvolved).find(pl => {
        return !!getSelectedProductionLines().find(productionLineSelected => {
          if (Number(pl.id) === Number(productionLineSelected)) {
            return true;
          } else {
            return getProductionLine(pl.id).collaboratingProductionLineIds.indexOf(Number(productionLineSelected.id)) >= 0;
          }
        });
      });
      return !!ok;
    } return false;
  };

  orderListUtil.filter = function (order) {
    var ok = false;
    if (order.defaultProductionLinesIds === "" || getSelectedProductionLines().length === 0) return false;
    order.defaultProductionLinesIds.split(",").forEach(function (pl) {
      getSelectedProductionLines().forEach(productionLineSelected => {
        if (Number(pl) === Number(productionLineSelected)) {
          ok = ok || true;
        } else {
          ok = ok || getProductionLine(pl).collaboratingProductionLineIds.indexOf(Number(productionLineSelected)) >= 0;
        }
      });
    });
    return ok;
  };

  orderListUtil.isFiltered = () => {
    return true;
  };
  orderListUtil.orderTemplate = data => {
    var t = $(".order-table-box-outer .order-table-box");
    t.data("scrollTop", t.scrollTop());
    t.data("scrollLeft", t.scrollLeft());

    orderListUtil.statesShown.forEach(function (state) {
      var t = $("<div class='tcontent'/>");
      var target = $("#" + state + ".order-table-box .tcontent,#" + state + ".order-table-box.tcontent");
      if (target.length === 0) return;


      data = data.filter(order => orderListUtil.show(order)).sort(function (a, b) {
        const aNumber = a.tableNumber;
        const bNumber = b.tableNumber;
        const aIsScheduled = isTakeawayTable(aNumber);
        const bIsScheduled = isTakeawayTable(bNumber);
        const aTableOccupation = getTableOccupation(a.tableOccupation);
        const bTableOccupation = getTableOccupation(b.tableOccupation);
        var atime = !aIsScheduled ? a.inStateTimeStamp[state] : aTableOccupation.bookedOccupationStart;
        var btime = !bIsScheduled ? b.inStateTimeStamp[state] : bTableOccupation.bookedOccupationStart;
        return atime - btime;
      });
      data.sort((a, b) => {
        if (a.tableOccupation===b.tableOccupation && alltimings.indexOf(a.timing) - alltimings.indexOf(b.timing) != 0) {
          return alltimings.indexOf(a.timing) - alltimings.indexOf(b.timing);
        }
        const timestampA = getSelectedProductionLines().map(pl => a.inStateTimeStampByProductionLine[pl] && a.inStateTimeStampByProductionLine[pl][state] ? a.inStateTimeStampByProductionLine[pl][state] : 0).reduce((a, b) => Math.max(a, b));
        const timestampB = getSelectedProductionLines().map(pl => b.inStateTimeStampByProductionLine[pl] && b.inStateTimeStampByProductionLine[pl][state] ? b.inStateTimeStampByProductionLine[pl][state] : 0).reduce((a, b) => Math.max(a, b));
        return timestampA - timestampB;
      }).forEach(function (order) {

        const thirdPartyOrder = getTableOccupation(order.tableOccupation)?.bookedProperties?.["thirdparty-order-number"];
        $("script#ordersTemplateCancelledAcceptedProducingDeliveringStateTableStyle")
          .tmpl({ da: order, state: state, stateTransitions: auth.myStatus.restaurant_settings.production_lines.stateTransitions, ...tmplparams(), isPickup, isHomeDelivery, thirdPartyOrder })
          .appendTo(t);
      });
      replaceContent(target, $(t));
    });
  };

  orderListUtil.updateOrdersDone = function () {
    topUpdateHooks();
  };

  $("#productionLineMainTemplate")
    .tmpl({ ...tmplparams(), hidePaid: true })
    .appendTo($("#main"));

  $("script#ordersTemplateCancelledAcceptedProducingDeliveringTableStyle")
    .tmpl({ stateTransitions: auth.myStatus.restaurant_settings.production_lines.stateTransitions, ...tmplparams() })
    .appendTo($("#orderList"));

  var name = "";
  auth.myStatus.restaurant_production_lines.forEach(function (line) {
    var selected = false;
    getSelectedProductionLines().forEach(productionLineSelected => {
        if (Number(productionLineSelected) === line.id) {
          selected = true;
        }
      });
    name += '<button onclick="toggleProductionLineSelected(' + line.id + ',this)" class="btn btn-info ' + (selected ? "active" : "") + '" data-toggle="toggle">' + line.name + "</button>";
  });
  $(".production-line-index-title").html(name);

  select($("#middle"));

  startpoll(serverSideMessageHandler, [
    {
      Restaurant: localStorage.restaurantSelected,
      Order: "*"
    },
    {
      Restaurant: localStorage.restaurantSelected,
      Menu: "*"
    },
    {
      Restaurant: localStorage.restaurantSelected,
      TableOccupation: "*"
    }
  ]);

  admin.getTables(function (tableLayouts) {
    tableLayout.tables = tableLayouts.restaurantTables;
    tableLayouts.restaurantTables.forEach(function (table) {
      tableLayout.tableMap.set(Number(table.number), table);
    });

    getTableOccupations(function (data) {
      orderListUtil.tableOccupations = data;
      updateTableMates();
      admin.getActiveMenuItems(function (categs) {
        admin.categories = categs;

        admin.getUnprocessedOrders([], orders => {
          orderListUtil.ordersCache = orders;
          orderListUtil.processOrders(orders)
        });

      }, localStorage.language);


      $("div#rejectionReason").on("shown.bs.modal", function (event) {
        var modal = $(this);
        var r = $(modal).find("#reason1");
        $(r).trigger("focus");
      });
    });
  });

  $("#orderList").click(event => {
    if (event.isDefaultPrevented()) return;

    if (event.originalEvent.selectionDone === true) return;

    $(".mainrow.selectable.selected").removeClass("selected");
  });
};

var printLabelTimeout;

const printLabel = (event, pl, orderss, reprint = false) => {
  event.stopPropagation();
  event.preventDefault();
  if (printLabelTimeout) {
    clearTimeout(printLabelTimeout);
  }
  const orders = orderss || $(event.target).parents(".orderrow").attr("orders");
  const tableOccupation = $(event.target).parents(".mainrow").attr("tableOccupation");
  const productionLine = auth.myStatus.restaurant_production_lines.find(p => p.id == pl)
  printLabelTimeout = setTimeout(() => {
    printLabelTimeout = undefined;
    get("adminService/" + localStorage.restaurantSelected + "/" + tableOccupation + "/printLabel?orderIds=" + orders + "&printer=" + productionLine.labelPrinter.id + "&productionLines=" + pl + "&reprint=" + reprint);
  }, 500);
}
const printAllLabels = (event, pl, reprint = false) => {
  event.stopPropagation();
  event.preventDefault();
  const orderss = $(event.currentTarget).parent().attr("orders");
  const orders = [];
  orderss.split(",").forEach(o => {
    orders.push(o);
    getOrderById(o).childOrders.filter(co => o.addition).forEach(co => {
      orders.push(co.id)
    })
  });
  const tableOccupation = $(event.currentTarget).parent().parent().attr("tableOccupation");
  const productionLine = auth.myStatus.restaurant_production_lines.find(p => p.id == pl)
  get("adminService/" + localStorage.restaurantSelected + "/" + tableOccupation + "/printLabel?orderIds=" + orders + "&printer=" + productionLine.labelPrinter.id + "&productionLines=" + pl + "&reprint=" + reprint);
}

const getSelectedProductionLines = () => {
  const pls = [];
  if (window?.location?.hash && window.location.hash.split("/").length > 2)
    window.location.hash.split("/")[3].split(",").forEach(productionLineSelected => {
      pls.push(productionLineSelected);
    });
  sessionStorage.productionLineSelected = pls.join(",");  
  return pls;
}

const toggleProductionLineSelected = (id, item) => {
  var pls = getSelectedProductionLines();
  if (pls.indexOf("" + id) !== -1) {
    pls.splice(pls.indexOf("" + id), 1);
    $(item).removeClass("active");
  } else {
    pls.push(id);
    $(item).addClass("active");
  }
  var s = "";
  pls.forEach(pl => {
    s += (s === "" ? "" : ",") + pl;
  });
  window.location.hash = "productionLinesMenu/productionLine/" + s;
  sessionStorage.productionLineSelected = s;
  processAllOrders(orderListUtil.ordersCache);
  updateOrders([]);
};


var prevCrc2 = null;
var crcErrorCount = 0;

function recoverFromEventSourceError(recovery = true, clearCache = false) {
  getTableOccupations(function (data) {
    orderListUtil.tableOccupations = data;
    updateTableMates();
    admin.getUnprocessedOrders([], orders => {
      orderListUtil.ordersCache = orders;
      orderListUtil.processOrders(orders)
    });
  });
}



function serverSideMessageHandler(message) {
  if (message.type === "timeout" && message.message === "true") {
    if (!orderListUtil.ordersCache) return;
    const crcs = orderListUtil.ordersCache.filter(o => o.recordState == "ACTIVE" && o.id > 0).sort((a, b) => a.id - b.id).map(o => {
      const t = allstates2.indexOf(o.originalState || o.state);
      return t >= 0 ? [o.id, t] : null;
    });
    if (message.crc2) {
      const crc = getCrc2();
      const crc2 = getCrc();
      if (message.crc2 !== crc) {
        //console.log(crcs);

        // console.log("crc " + message.crc + "/" + message.crc2);
        if (crcErrorCount && prevCrc2 != message.crc2) {
          //post("restaurantService/" + localStorage.restaurantSelected + "/logOrderDifference", crcs, undefined, false, 0, true).fail(() => auth.ajaxError = false);
          console.error("crc error production-line localOrderCount=" + crc2 + "/" + crc + " serverOrderCount=" + message.crc + "/" + message.crc2 + " new Orders:" + orderListUtil.newOrders.length);
          prevCrc2 = message.crc2;
        }
        if (crcErrorCount++ > 5) {
          crcErrorCount = 0;
          if (crc > message.crc)
            console.error("crc error (" + crcErrorCount + ") ahead production-line localOrderCount=" + crc2 + "/" + crc + " serverOrderCount=" + message.crc + "/" + message.crc2);
          else
            console.error("crc error (" + crcErrorCount + ") behind production-line localOrderCount=" + crc2 + "/" + crc + " serverOrderCount=" + message.crc + "/" + message.crc2);
          recoverFromEventSourceError(true, true);
          return;
        }
      } else {
        if (prevCrc2 != message.crc2) {
          //console.log("crc ok localOrderCount=" + crc2 + "/" + crc + " serverOrderCount=" + message.crc + "/" + message.crc2);
          prevCrc2 = message.crc2;
        }
        if (crcErrorCount) { //crc is ok 
          if (crcErrorCount++ > 1) {
            console.error("crc ok (" + crcErrorCount + ") production-line localOrderCount=" + crc2 + "/" + crc + " serverOrderCount=" + message.crc + "/" + message.crc2);
          }
          crcErrorCount = 0;
        }
      }
    }
    return;
  }
  if (message.type === "message") {
    const value = typeof message.value !== "undefined" ? message.value : message.message;
    auth.showServerSideMessageBubble(value);
    return;
  }
  if (message.type === "show") {
    const key = message.Printer;
    if (!message.message) {
      $("div.messages span[key = '" + key + "'").remove();
    } else {
      const msg = eval(message.message);
      if ($('div.messages span').filter((ind, span) => $(span).attr("msg") == msg).length === 0)
        $("<span key='" + key + "' msg='" + msg + "'>" + msg + "</span>").appendTo($("div.messages"));
    }
    return;
  }
  if (message.type === "refresh") {
    if (message.message === "order changed" || message.message === "order state changed" || message.message === "new order" || message.message === "new order selected") {
      if (message.data) {
        if (message.data.orders.filter(o => o && orderListUtil.filter(o) && o.state === "accepted" && getOrderById(o.id)?.state !== "accepted").length) {
          playNewAcceptedOrderSound();
        }
        update(message.data);
      } else admin.getOrder(message.TableOccupation, message.Order, updateOrders);
    } else if (message.message === "order cancelled") {
      if (message.data) {
        deleteOrders(message.Order, true);
        update(message.data);
      } else {
        deleteOrders(message.Order);
      }
    } else if (message.message === "menu changed") {
      admin.getActiveMenuItems(function (categs) {
        admin.categories = categs;
        updateOrders([]);
      }, localStorage.language);
    } else if (message.message === "table unlocked") {
      if (message.data) update(message.data);
      else {
        deleteTableOccupations(message.TableOccupation);
        updateOrders([]);
      }
    } else {
      if (message.data) {
        update(message.data);
      }
      // reload();
    }
  }
}

/*
const reload = () => {
  var id = orderListUtil.selected.attr("id");
  var orderId = orderListUtil.selected.attr("orderId");
  var details = $("tr#" + id + ".detailrow.nothidden").length > 0;
  admin.getUnprocessedOrders(function(data) {
    processOrders(data);
    setSelected(id);
    if (details) {
      _show(orderListUtil.selected, true);
      $("tr#" + id + ".detailrow.nothidden").each(function(ind, row) {
        if ($(row).attr("orderId") === orderId) {
          _show($(row));
        }
      });
    }
  });
};
*/

function topUpdateHooks() {
  $(".orderTable.table-style .order-table-box-outer .order-table-box .mainrow").each((ind, box) => {
    var lastChild = $(box).find("div.order-table-box-content > div:not(.change-state-to) > div:last-child");

    var pos = lastChild.offset();
    var boxpos = $(box).offset();
    var bottom = pos.top - boxpos.top + lastChild.get(0).getBoundingClientRect().height;
    var right = pos.left - boxpos.left + lastChild.get(0).getBoundingClientRect().width;
    var height = $(box).outerHeight();
    var width = $(box).outerWidth();

    if (right > width + 1 || bottom > height + 1) {
      $(box).css("min-width", "calc(" + (20 + Math.floor(right / width) * 20) + "em)");
    }
  });

  var t = $(".order-table-box-outer .order-table-box");
  t.scrollTop(t.data("scrollTop"));
  t.scrollLeft(t.data("scrollLeft"));

  orderListUtil.updateHooks();
}
